import { useEffect, useState } from "react";
import {
  clearSupportSession,
  getStoredSupportUser,
  getSupportSession,
} from "../services/supportApi";

export default function useSupportSessionGuard() {
  const [checking, setChecking] = useState(true);
  const [supportUser, setSupportUser] = useState(() => getStoredSupportUser());

  useEffect(() => {
    let active = true;

    const verifySession = async () => {
      try {
        const nextSupportUser = await getSupportSession();
        if (!active) return;
        setSupportUser(nextSupportUser);
      } catch {
        if (!active) return;
        setSupportUser(null);
        void clearSupportSession({ server: false, reason: "expired" });
      } finally {
        if (active) {
          setChecking(false);
        }
      }
    };

    verifySession();
    return () => {
      active = false;
    };
  }, []);

  return { checking, supportUser };
}
